import React, { FC } from 'react'

import { icons } from '@/constants/icons'
import { LoginHeaderProps } from '@/types/componentsPropsTypes'

import { Description, HeaderElem, HeaderLogo, Title } from './styles'

export const LoginHeader: FC<LoginHeaderProps> = ({
  showLogo = true,
  title,
  description,
  headerHeight = 'auto',
}) => {
  return (
    <HeaderElem $headerHeight={headerHeight}>
      {showLogo && (
        <HeaderLogo
          src={icons.logoApp.logoWhite}
          alt="logo"
          className="header-logo"
        />
      )}
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </HeaderElem>
  )
}
